import {observer} from "mobx-react";
import _ from "lodash";
import {ModalBtn} from "../../components/Modals";
import {Tabs} from "antd";
import Leaderboard from "./Leaderboard";
import React from "react";

export default observer(({d, teamById, asLink, modalProps={}}) => {
  let prelims = _.reject(d.pools, 'knockout');

  if (prelims.length < 2 || !_.every(prelims, {status: "done"}))
    return null;

  return <ModalBtn title={d.name} asLink={asLink} style={{top: 0}} footer={null} width={900} text="Prelims Result" {...modalProps}>
    <Tabs>
      {prelims.map(dp => <Tabs.TabPane tab={dp.name} key={dp.id}>
        <Leaderboard division={dp} teamById={teamById}/>
      </Tabs.TabPane>)}
    </Tabs>
  </ModalBtn>
})
